module.exports = __webpack_public_path__ + "static/media/素炸百頁豆腐便當.b830533d.jpg";